import React from 'react';
import MyRouter from './pages/MyRouter';
import Header from './components/header/Header';
import Footer from './components/footer/Footer';

const App = () => (
  <div className="App font-Rubik  bg bg-body">
    <Header />
    <main>
      <MyRouter />
    </main>
    <Footer />
  </div>
);

export default App;
